<div mat-dialog-content>
  {{message}}
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="basic" class="me-2" (click)="onNoClick()">No</button>
  <button mat-raised-button color="primary" class="me-2 yesButton" [mat-dialog-close]="true" cdkFocusInitial >Yes</button>
</div>
